export default __webpack_public_path__ + "static/media/head.c1a1bd0a.png";